export default __webpack_public_path__ + "c08aaa22c182b9faefe11f7bd7b96086.png";